(function() {

  'use strict';

  function EncomendaResource($resource, URLAPIPEDIDO, URLAPICOLETA) {
    return $resource(URLAPIPEDIDO + '/v1/pedidos/:orderId/manual/:itemId', {
      orderId: '@_orderId',
      itemId: '@_itemId',
    }, {
      getPackages: {
        method: 'GET',
        url: URLAPIPEDIDO + '/v1/pedidos/:provider:search',
        isArray: true,
        params: {
          provider: '@provider',
          search: '@search'
        }
      },
      savePackages: {
        method: 'POST',
        url: URLAPIPEDIDO + '/v1/pedidos/:provider',
        params: {
          provider: '@provider'
        }
      },
      buscarHorariosAgendamentoColeta: {
        method: 'GET',
        url: URLAPICOLETA + '/v1/horarios-coleta',
        isArray: true
      },
      agendarColeta: {
        method: 'POST',
        url: URLAPICOLETA + '/v1/pedidos/:pedidoId/agendar-coleta',
        params: {
          pedidoId: '@pedidoId'
        }
      },
      cancelarColeta: {
        method: 'POST',
        url: URLAPICOLETA + '/v1/pedidos/:pedidoId/cancelar-coleta',
        params: {
          pedidoId: '@pedidoId'
        }
      },
      podeMudarAgendamento: {
        method: 'GET',
        url: URLAPICOLETA + '/v1/pedidos/:pedidoId/pode-mudar-agendamento',
        params: {
          pedidoId: '@pedidoId'
        }
      },
      bloquear: {
        method: 'POST',
        url: URLAPIPEDIDO + '/v1/encomendas/:encomendaId/bloquear',
        params: {
          encomendaId: '@encomendaId'
        }
      },
      podeBloquear: {
        method: 'GET',
        url: URLAPIPEDIDO + '/v1/encomendas/:encomendaId/pode-bloquear',
        params: {
          encomendaId: '@encomendaId'
        }
      },
      deletarTodas: {
        method: 'DELETE',
        url: URLAPIPEDIDO + '/v1/pedidos',
        hasBody: true,
      },
      cancelarEncomendas: {
        method: 'DELETE',
        url: URLAPIPEDIDO + '/v2/pedidos/:pedidoId',
        params: {
          pedidoId: '@pedidoId'
        },
        hasBody: true,
      }
    });
  }

  angular.module('mandaeApp')
    .factory('EncomendaResource', EncomendaResource);

})();
